import React from 'react'

const AuthContext = React.createContext({
  authUser: null,
  updateAuthUser: () => {},
})

export default AuthContext
